import titleClasses from './Title.module.css';

export const TitleOverrideClassNames = () => ({
  root: titleClasses.root
});
